import { Clip, Composition, TrackId } from './types';

/**
 * Returns the clips for a track, sorted by start time.
 * Used by the timeline to render each track row.
 */
export const getClipsInTrack = (c: Composition, trackId: TrackId): Clip[] =>
  Object.values(c.clipsById)
    .filter(clip => clip.trackId === trackId)
    .sort((a, b) => a.start - b.start);
